import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnFormCheckboxModule } from '@lib/form/checkbox';
import { SnFormChipsAutocompleteModule } from '@lib/form/chips-autocomplete';
import { SnDetailedCheckboxModule } from '@lib/form/detailed-checkbox';
import { SnFormSearchListModule } from '@lib/form/search-list';
import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnAvatarModule } from '@lib/ui/avatar';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnMenuModule } from '@lib/ui/menu';

import {
  ShareTableComponent,
  SnShareListComponent,
  FsShareListV2Component,
  SnShareStatusComponent,
  SnObjectOwnerComponent,
  SnShareParamsComponent,
  SnShareInviteFormComponent,
  FsShareInviteFormV2Component,
  SnObjectShareStatusComponent,
  ShareDetailsV2Component,
} from './components';
import { BulkShareDialogComponent } from './components/bulk-share-dialog/bulk-share-dialog.component';
import { ShareDetailsComponent } from './components/share-details/share-details.component';
import { 
  ShareDrawerContainer, 
  ShareDrawerV2Container, 
  ShareConfigDrawerContainer, 
  ShareConfigDrawerV2Container, 
  ShareInviteDrawerContainer,
  ShareInviteDrawerV2Container,
} from './containers';
import { SnShareUiService } from './services';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatProgressBarModule,
    MatRippleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    // Sn UI Libs
    SnActionsModule,

    SnAvatarModule,
    SnButtonModule,
    SnCommonModule,
    SnDataListModule,
    SnDrawerModule,
    SnFormModule,
    SnFormCheckboxModule,
    SnFormChipsAutocompleteModule,
    SnFormSearchListModule,
    SnDetailedCheckboxModule,
    SnIconModule,
    SnListModule,
    SnMenuModule,
    // Other
    TranslationModule,
  ],
  exports: [
    ShareTableComponent,
    SnShareListComponent,
    FsShareListV2Component,
    SnShareParamsComponent,
    SnShareStatusComponent,
    SnObjectOwnerComponent,
    SnShareInviteFormComponent,
    FsShareInviteFormV2Component,
    SnObjectShareStatusComponent,
    BulkShareDialogComponent,
    TranslationModule,
  ],
  declarations: [
    ShareTableComponent,
    SnShareListComponent,
    FsShareListV2Component,
    ShareDrawerContainer,
    ShareDrawerV2Container,
    ShareDetailsComponent,
    ShareDetailsV2Component,
    SnShareParamsComponent,
    SnShareStatusComponent,
    SnObjectOwnerComponent,
    ShareConfigDrawerContainer,
    ShareConfigDrawerV2Container,
    ShareInviteDrawerContainer,
    ShareInviteDrawerV2Container,
    SnShareInviteFormComponent,
    FsShareInviteFormV2Component,
    SnObjectShareStatusComponent,
    BulkShareDialogComponent,
  ],
  providers: [SnShareUiService],
})
export class SnShareModule {}
